import { render, staticRenderFns } from "./StatisticsView.vue?vue&type=template&id=2c6afc52&scoped=true&"
import script from "./StatisticsView.vue?vue&type=script&lang=js&"
export * from "./StatisticsView.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsView.vue?vue&type=style&index=0&id=2c6afc52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6afc52",
  null
  
)

export default component.exports